import SplashPage from '@scoir/splash-page'
import presenceArtwork from './presence.png'
import messagingArtwork from './messaging.png'
import presenceInsights from './presenceInsights.png'

type EngageSplashPageProps = {
  type: 'presence' | 'messaging'
  featureEnabled?: boolean
}

export const EngageSplashPage = ({ type, featureEnabled = false }: EngageSplashPageProps) => {
  let title,
    subtitle,
    body = '',
    artwork,
    alt = '',
    buttonHref,
    buttonText: string | undefined = 'Learn More'

  switch (type) {
    case 'presence':
      title = 'Upgrade to Premium Presence'
      subtitle = 'Own your presence on the network where nearly 1 million verified students are searching with intent.'
      body =
        'Students are 87% more likely to engage with your college when you upgrade to Premium Presence (...plus, their supporters are here too 👀).'
      artwork = presenceArtwork
      alt = 'Premium Presence'
      buttonHref = 'https://www.scoir.com/colleges/product/premium-presence/upgrade'
      break
    case 'messaging':
      title = 'Outreach Messaging'
      subtitle = 'Engage interested students and families as early as freshman year'
      body = 'Students are 3x more likely to apply to your institution after receiving a message.'
      artwork = messagingArtwork
      alt = 'Outreach Messaging'
      buttonHref = 'https://www.scoir.com/colleges/feature-messaging'
      break
    default:
      break
  }
  if (featureEnabled) {
    title = undefined
    subtitle = 'You don’t have permission to view this page'
    body = 'Contact your school’s administrator to grant you the appropriate access'
    buttonText = undefined
    artwork = presenceInsights
  }
  return (
    <SplashPage
      title={title}
      titleColor="college"
      subtitle={subtitle}
      body={body}
      artwork={artwork}
      artworkProps={{ alt }}
      buttonText={buttonText}
      buttonHref={buttonHref}
      showLearnMoreLink={false}
      newTab
    />
  )
}

export default EngageSplashPage
